/**
 * Dados apenas para exibição na página /upgrade.
 * Códigos devem coincidir com o backend (PlanoSaasService).
 */

const S = {
  workspace: { section: 'Workspace' },
  agendaBlock: { section: 'Agenda e visualização' },
  taskBlock: { section: 'Recursos de Task' },
  crmBlock: { section: 'Recursos de CRM' },
  proAdvanced: { section: 'Recursos avançados (Pro e Corporativo)' }
}

const PRO_ADVANCED_ROWS = [
  S.proAdvanced,
  { label: 'Editar layout da Task (desktop/mobile)', detail: 'Sim' },
  { label: 'Forms personalizados', detail: 'Sim' },
  { label: 'Menu Preview no Kanban', detail: 'Sim' },
  { label: 'Grupos de permissão no Kanban', detail: 'Sim' }
]

const PRO_ADVANCED_ROWS_NO = [
  S.proAdvanced,
  { label: 'Editar layout da Task (desktop/mobile)', detail: 'Não' },
  { label: 'Forms personalizados', detail: 'Não' },
  { label: 'Menu Preview no Kanban', detail: 'Não' },
  { label: 'Grupos de permissão no Kanban', detail: 'Não' }
]

function workspaceRows(task, crm, users) {
  return [
    S.workspace,
    { label: 'Workspaces de Task (como dono)', detail: String(task) },
    { label: 'Workspaces de CRM (como dono)', detail: String(crm) },
    { label: 'Usuários por workspace', detail: String(users) }
  ]
}

/** Feature rows: Task — matriz Free (plano.md) */
const TASK_ROWS_FREE = [
  S.taskBlock,
  { label: 'História da Task', detail: 'Não' },
  { label: 'Informações da Task', detail: 'Sim' },
  { label: 'Checklist da Task', detail: 'Sim' },
  { label: 'Anexos na Task', detail: 'Não' },
  { label: 'Cor da Task', detail: 'Sim' },
  { label: 'Financeiro na Task', detail: 'Não' },
  { label: 'Processo da tarefa', detail: 'Sim' },
  { label: 'Tags da tarefa', detail: 'Sim' },
  { label: 'Usuários atribuídos na Task', detail: 'Sim' },
  { label: 'Controle de atividade da Task', detail: 'Não' },
  { label: 'Agendamento da Task', detail: 'Não' },
  { label: 'Histórico (chat) da Task', detail: 'Não' }
]

const TASK_ROWS_FULL = [
  S.taskBlock,
  { label: 'História da Task', detail: 'Sim' },
  { label: 'Informações da Task', detail: 'Sim' },
  { label: 'Checklist da Task', detail: 'Sim' },
  { label: 'Anexos na Task', detail: 'Sim' },
  { label: 'Cor da Task', detail: 'Sim' },
  { label: 'Financeiro na Task', detail: 'Sim' },
  { label: 'Processo da tarefa', detail: 'Sim' },
  { label: 'Tags da tarefa', detail: 'Sim' },
  { label: 'Usuários atribuídos na Task', detail: 'Sim' },
  { label: 'Controle de atividade da Task', detail: 'Sim' },
  { label: 'Agendamento da Task', detail: 'Sim' },
  { label: 'Histórico (chat) da Task', detail: 'Sim' }
]

const CRM_WHATSAPP_ROW = (detail) => ({
  label: 'Integração com WhatsApp no CRM',
  detail,
  highlight: 'whatsapp',
  tagline: 'Conecte o WhatsApp Business e converse com leads no Kanban'
})

/** CRM — Free: tudo Não (WhatsApp após Anexos) */
const CRM_ROWS_FREE = [
  S.crmBlock,
  { label: 'Relatórios CRM', detail: 'Não' },
  { label: 'Histórico (chat) do CRM', detail: 'Não' },
  { label: 'Informações de contato do CRM', detail: 'Não' },
  { label: 'Informações do negócio do CRM', detail: 'Não' },
  { label: 'Origem do lead no CRM', detail: 'Não' },
  { label: 'Cor do lead no CRM', detail: 'Não' },
  { label: 'Usuários atribuídos no CRM', detail: 'Não' },
  { label: 'Agendamento no CRM', detail: 'Não' },
  { label: 'Tags no CRM', detail: 'Não' },
  { label: 'Anexos e imagens no CRM', detail: 'Não' },
  CRM_WHATSAPP_ROW('Não')
]

function crmRowsNitro(whatsappSim) {
  return [
    S.crmBlock,
    { label: 'Relatórios CRM', detail: 'Sim' },
    { label: 'Histórico (chat) do CRM', detail: 'Sim' },
    { label: 'Informações de contato do CRM', detail: 'Sim' },
    { label: 'Informações do negócio do CRM', detail: 'Sim' },
    { label: 'Origem do lead no CRM', detail: 'Sim' },
    { label: 'Cor do lead no CRM', detail: 'Sim' },
    { label: 'Usuários atribuídos no CRM', detail: 'Sim' },
    { label: 'Agendamento no CRM', detail: 'Sim' },
    { label: 'Tags no CRM', detail: 'Sim' },
    { label: 'Anexos e imagens no CRM', detail: 'Sim' },
    CRM_WHATSAPP_ROW(whatsappSim ? 'Sim' : 'Não')
  ]
}

export const PLAN_DISPLAY_CATALOG = {
  FREE: {
    title: 'Free',
    subtitle: null,
    description: 'Plano gratuito para começar com Task e KANBAN no essencial.',
    precoLabel: 'R$ 0,00 / mês',
    heroMetrics: { taskWs: '1', crmWs: '0', usersWs: '1' },
    featureRows: [
      ...workspaceRows(1, 0, 1),
      S.agendaBlock,
      { label: 'Agenda', detail: 'Não' },
      { label: 'KANBAN', detail: 'Sim' },
      ...TASK_ROWS_FREE,
      ...CRM_ROWS_FREE,
      ...PRO_ADVANCED_ROWS_NO
    ]
  },
  START_VERIFICADO: {
    title: 'Start',
    subtitle: 'Nitro',
    description: 'Para equipes que precisam de CRM completo, agenda e Task sem limitações intermediárias.',
    precoLabel: 'R$ 47,00 / mês',
    heroMetrics: { taskWs: '2', crmWs: '2', usersWs: '5' },
    featureRows: [
      ...workspaceRows(2, 2, 5),
      S.agendaBlock,
      { label: 'Agenda', detail: 'Sim' },
      { label: 'KANBAN', detail: 'Sim' },
      ...TASK_ROWS_FULL,
      ...crmRowsNitro(false),
      ...PRO_ADVANCED_ROWS_NO
    ]
  },
  PRO_VERIFICADO: {
    title: 'Pro',
    subtitle: 'Nitro Plus',
    description: 'Escala maior, WhatsApp no CRM e limites generosos por workspace.',
    precoLabel: 'R$ 97,00 / mês',
    heroMetrics: { taskWs: '10', crmWs: '10', usersWs: '25' },
    featureRows: [
      ...workspaceRows(10, 10, 25),
      S.agendaBlock,
      { label: 'Agenda', detail: 'Sim' },
      { label: 'KANBAN', detail: 'Sim' },
      ...TASK_ROWS_FULL,
      ...crmRowsNitro(true),
      ...PRO_ADVANCED_ROWS
    ]
  },
  CORPORATIVO: {
    title: 'Corporativo',
    subtitle: null,
    description: 'Solução sob medida para operação em escala. Limites e integrações negociados com o time comercial.',
    precoLabel: 'Entrar em contato',
    heroMetrics: { taskWs: 'Sob medida', crmWs: 'Sob medida', usersWs: 'Sob medida' },
    featureRows: [
      S.workspace,
      { label: 'Workspaces de Task (como dono)', detail: 'Sob medida' },
      { label: 'Workspaces de CRM (como dono)', detail: 'Sob medida' },
      { label: 'Usuários por workspace', detail: 'Sob medida' },
      S.agendaBlock,
      { label: 'Agenda', detail: 'Sim' },
      { label: 'KANBAN', detail: 'Sim' },
      ...TASK_ROWS_FULL,
      ...crmRowsNitro(true),
      ...PRO_ADVANCED_ROWS,
      { section: 'Contrato' },
      {
        label: 'Detalhes comerciais',
        detail: 'Definidos em contrato'
      }
    ]
  }
}

export function getPlanDisplay(codigo) {
  if (!codigo) return null
  return PLAN_DISPLAY_CATALOG[codigo] || null
}
